/* Wrapama delivery estimate by zip code.
   Shows "Estimated delivery <date>" on product pages (top of the buy box, under the title and rating) and in the cart (above checkout).
   Transit days come from the FedEx delivery-days sheet (origin NY 12603), keyed by the first 3 digits of the zip. */
(function () {
  if (window.__wrpmEta) return;
  window.__wrpmEta = 1;

  /* ---- settings (edit here) ---- */
  var CUTOFF_HOUR = 15;   // orders placed before this hour, Eastern time, ship the same business day (15 = 3pm)
  var EXTRA_HANDLING = 0; // extra business days before an order ships
  var WINDOW_DAYS = 0;    // 0 = single date; 1 = show a two-day window
  var CLOSED = [];        // days with no shipping or delivery, e.g. ["2026-11-26","2026-12-25"]
  var PHONE = "844-712-WRAP (9727)";
  /* FedEx transit days by zip prefix range: "first-last:days" */
  var RANGES = "010-038:1 039-049:2 050-089:1 100-200:1 201-201:2 203-219:1 220-319:2 320-339:3 341-349:3 350-385:2 386-397:3 400-499:2 500-528:3 530-549:2 550-567:4 570-588:3 590-599:4 600-658:2 660-831:3 832-865:5 870-884:3 890-961:5 967-968:6 970-994:5 995-999:6";
  /* ------------------------------ */

  var customerZip = (document.currentScript && document.currentScript.getAttribute("data-zip")) || "";
  var days = {};
  RANGES.split(" ").forEach(function (r) {
    var m = r.split(/[-:]/);
    for (var i = +m[0]; i <= +m[1]; i++) days[("00" + i).slice(-3)] = +m[2];
  });

  function nowET() {
    var p = {};
    new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", hourCycle: "h23" })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = +x.value; });
    return { d: new Date(Date.UTC(p.year, p.month - 1, p.day)), h: p.hour % 24, m: p.minute };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function isOpen(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && CLOSED.indexOf(iso(d)) < 0; }
  function addDays(d, n) { d = new Date(d); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isOpen(d)) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString("en-US", { timeZone: "UTC", weekday: "short", month: "short", day: "numeric" }); }
  function cutoffLabel() { return (CUTOFF_HOUR > 12 ? CUTOFF_HOUR - 12 : CUTOFF_HOUR) + (CUTOFF_HOUR >= 12 ? "pm" : "am") + " ET"; }

  function estimate(zip) {
    var t = days[zip.substr(0, 3)];
    if (!t) return null;
    var n = nowET(), ship = n.d, today = isOpen(ship) && n.h < CUTOFF_HOUR;
    if (!today) ship = addDays(ship, 1);
    ship = addDays(ship, EXTRA_HANDLING);
    var from = addDays(ship, t);
    return { ship: ship, from: from, to: WINDOW_DAYS ? addDays(from, WINDOW_DAYS) : null, today: today && !EXTRA_HANDLING };
  }
  window.wrpmEstimate = estimate;

  var KEY = "wrpm_zip";
  function saved() { try { return localStorage.getItem(KEY) || ""; } catch (e) { return ""; } }
  function save(z) { try { localStorage.setItem(KEY, z); } catch (e) {} }

  var CSS = ".wrpm-eta{font-family:var(--wrpm-font,'Archivo',system-ui,sans-serif);display:flex;flex-wrap:wrap;align-items:center;gap:10px 14px;border:1.5px solid #F2D479;border-radius:10px;padding:13px 16px;margin:0 0 16px;background:#FFF6D6;color:var(--wrpm-ink,#21272A);text-align:left;}"
    + ".wrpm-eta__head{display:flex;align-items:center;gap:8px;font-size:16px;font-weight:900;color:var(--wrpm-ink,#21272A);white-space:nowrap;}"
    + ".wrpm-eta__head svg{color:var(--wrpm-accent,#F05423);}"
    + ".wrpm-eta *{box-sizing:border-box;}"
    + ".wrpm-eta svg{flex-shrink:0;}"
    + ".wrpm-eta__row{display:flex;gap:8px;flex:1 1 210px;min-width:0;}"
    + ".wrpm-eta__row input{flex:1;min-width:0;width:100%;height:42px;border:1.5px solid var(--wrpm-line-strong,#D8D5C9);border-radius:8px;padding:0 12px;font-family:inherit;font-size:16px;font-weight:600;color:inherit;background:#fff;margin:0;}"
    + ".wrpm-eta__row input:focus{outline:none;border-color:var(--wrpm-accent,#F05423);}"
    + ".wrpm-eta__row button{height:42px;padding:0 20px;border:none;border-radius:8px;background:var(--wrpm-accent,#F05423);color:#fff;font-family:inherit;font-size:14px;font-weight:800;cursor:pointer;width:auto;}"
    + ".wrpm-eta__row button:hover{background:var(--wrpm-accent-dark,#D4451A);}"
    + ".wrpm-eta__out{flex:1 1 100%;font-size:13px;line-height:1.45;color:var(--wrpm-body,#4B5257);}"
    + ".wrpm-eta__out strong{display:flex;align-items:center;gap:8px;font-size:18px;font-weight:900;color:var(--wrpm-success-ink,#3F5B27);letter-spacing:-.01em;margin-bottom:3px;}"
    + ".wrpm-eta__out .err{color:#B3261E;font-weight:700;}"
    + ".wrpm-eta__out button{background:none;border:none;padding:0;margin:0;font:inherit;font-weight:700;color:var(--wrpm-accent,#F05423);cursor:pointer;text-decoration:underline;width:auto;height:auto;}"
    + ".wrpm-eta.has-result{background:var(--wrpm-success-bg,#EDF3E7);border-color:var(--wrpm-success-line,#BCD3A8);}"
    + ".wrpm-eta.has-result .wrpm-eta__row,.wrpm-eta.has-result .wrpm-eta__head{display:none;}";

  /* Make the existing "Order before 3:00pm EST — ships today" line in the rating row stand out as a pill on its own line */
  var PILL_CSS = ".wrpm-cutpill{flex:0 1 auto;display:inline-flex!important;align-items:center;gap:7px!important;max-width:100%;margin-top:2px;padding:7px 13px;border:1.5px solid var(--wrpm-accent,#F05423);border-radius:999px;background:#FFF1EA;font-size:14px!important;font-weight:800!important;color:var(--wrpm-ink,#21272A)!important;line-height:1.2;}"
    + ".wrpm-cutpill svg{flex-shrink:0;color:var(--wrpm-accent,#F05423);}"
    + ".wrpm-cutpill b{color:var(--wrpm-accent,#F05423);font-weight:900;}"
    + ".wrpm-cutpill-br{flex-basis:100%;height:0;}"
    + ".wrpm-cutpill-hide{display:none!important;}";
  var CLOCK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg>';
  function pillify() {
    var els = [].slice.call(document.querySelectorAll(".v4pd-rate .cut, .mpd-cut"));
    els.forEach(function (el) {
      var t = el.textContent.trim();
      if (!/^order/i.test(t)) return;
      var html = t.replace(/(\d{1,2}:\d{2}\s*(am|pm)\s*[A-Z]{2,4}|\d{1,2}\s*(am|pm)\s*[A-Z]{2,4})/i, "<b>$1</b>").replace(/(ships today)/i, "<b>$1</b>");
      el.innerHTML = CLOCK + "<span>" + html + "</span>";
      el.classList.add("wrpm-cutpill");
      var prev = el.previousElementSibling;
      if (prev && prev.classList.contains("sep")) prev.classList.add("wrpm-cutpill-hide");
      var br = document.createElement("span"); br.className = "wrpm-cutpill-br"; el.parentNode.insertBefore(br, el);
    });
  }
  var TRUCK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 4h14v12H1zM15 9h4l4 4v3h-8z"/><circle cx="6" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/></svg>';

  var boxes = [];
  function render(box, zip, quiet) {
    var inp = box.querySelector("input"), out = box.querySelector(".wrpm-eta__out");
    if (!/^\d{5}$/.test(zip)) {
      if (!quiet) { out.hidden = false; out.innerHTML = '<span class="err">Enter a 5-digit zip code.</span>'; }
      return false;
    }
    var e = estimate(zip);
    if (!e) {
      box.classList.remove("has-result"); out.hidden = false;
      out.innerHTML = '<span class="err">We couldn\'t find an estimate for ' + zip + ".</span> Call " + PHONE + " and we'll check it.";
      return false;
    }
    inp.value = zip;
    out.innerHTML = "<strong>" + TRUCK + "Estimated delivery " + fmt(e.from) + (e.to ? " – " + fmt(e.to) : "") + "</strong>"
      + "To " + zip + ' · <button type="button">Change</button> · '
      + (e.today ? "Order before " + cutoffLabel() + " and it ships today." : "Ships " + fmt(e.ship) + ".")
      + " Estimate for case orders shipped by FedEx.";
    out.hidden = false; box.classList.add("has-result");
    out.querySelector("button").addEventListener("click", function () {
      box.classList.remove("has-result"); out.hidden = true; inp.focus(); inp.select();
    });
    return true;
  }
  function make() {
    var box = document.createElement("div");
    box.className = "wrpm-eta";
    box.innerHTML = '<div class="wrpm-eta__head">' + TRUCK + "<span>When will it arrive?</span></div>"
      + '<div class="wrpm-eta__row"><input type="text" inputmode="numeric" autocomplete="postal-code" maxlength="5" placeholder="Enter zip code" aria-label="Zip code"><button type="button">Check</button></div>'
      + '<div class="wrpm-eta__out" hidden aria-live="polite"></div>';
    var inp = box.querySelector("input");
    function go() {
      var z = inp.value.trim();
      if (render(box, z)) { save(z); boxes.forEach(function (b) { if (b !== box) render(b, z, true); }); }
    }
    inp.addEventListener("input", function () { inp.value = inp.value.replace(/\D/g, "").slice(0, 5); });
    inp.addEventListener("keydown", function (ev) { if (ev.key === "Enter") { ev.preventDefault(); go(); } });
    box.querySelector(".wrpm-eta__row button").addEventListener("click", go);
    boxes.push(box);
    return box;
  }
  function mount() {
    var st = document.createElement("style"); st.textContent = CSS + PILL_CSS; document.head.appendChild(st);
    pillify();
    var rate = document.querySelector(".v4pd-rate");         // desktop product page: top of the buy box, under the title and rating
    if (rate) rate.parentNode.insertBefore(make(), rate.nextSibling);
    var mrate = document.querySelector(".mpd-rate");         // phone product page: under the title and rating
    if (mrate) mrate.parentNode.insertBefore(make(), mrate.nextSibling);
    var co = document.querySelector(".ct-checkout");         // cart: above checkout (skipped for freight-quoted pallet carts)
    if (co && !document.querySelector(".ct-freight")) co.parentNode.insertBefore(make(), co);
    var z = (saved() || customerZip || "").slice(0, 5);
    if (z) boxes.forEach(function (b) { render(b, z, true); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mount); else mount();
})();
